import { AbstractEntity, PropertyValuesDictionary, Transaction, UiData } from "plethora-lib" // GENERATED
import {
  DataTypeShapeType,
  DataTypeDirection,
  DataTypeSize,
  DataTypeColor,
} from "../GeneratedClasses/GeneratedDataTypes" // GENERATED
import { GeneratedSimulationConfig } from "../GeneratedClasses/GeneratedSimulationConfig" // GENERATED

export class SimulationConfig extends GeneratedSimulationConfig {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super(id, propertyValues, uiData)

    const data = {
      id: this.id,
      backGround: this.getBackground(),
      hero: this.getHunter(),
    }
    console.log(this.getBackground(), this.getHunter())
    gameInstance.SendMessage("GridManager", "CreateSimulationConfig", JSON.stringify(data))
  }

  public onDelete(uiData: UiData): void /* GENERATED */ {
    super.onDelete(uiData)
    // YOUR CODE HERE
  }

  public onDestory(): void /* GENERATED */ {
    super.onDestory()
    // YOUR CODE HERE
  }

  public onSetHighlight(highlight: boolean): void /* GENERATED */ {
    super.onSetHighlight(highlight)
    // YOUR CODE HERE
  }

  protected onBackgroundUpdate(newValue: string, oldValue: string, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onHunterUpdate(newValue: string, oldValue: string, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }
}
